import type { TenantConfig } from '@/types/TenantConfig'

const green = '#3b8001'
const red = '#d3181f'

export const tff: TenantConfig = {
  logo: 'assets/tff/static/logo.png',
  teaserImageSize: {
    width: 430,
    height: 364,
  },
  titleInsideContentColumn: true,
  themeOptions: {
    primaryColor: green,
    secondaryColor: red,
    headerBackground: green,
    headerBottomBorder: `3px solid ${red}`,
    logoHeight: '120px',
    headerHeight: '140px',
    footerBackgroundColor: green,
    footerTextColor: 'white',
    cartHeaderBackgroundColor: 'white',
    cartHeaderTextColor: 'black',
    cartHeaderBorder: '1px solid var(--light-gray)',
  },
  componentOptions: {
    cartWidget: {
      dateTimeFormat: 'ddd D MMM @ h:mm A',
    },
    stripeCreditCard: {
      fontFaceStylesheet: 'https://use.typekit.net/ycx6dpc.css',
    },

    completedOrdersRoute: {
      completedImage: {
        mobile: 'assets/tff/static/completed.jpg',
        desktop: 'assets/tff/static/completed-wide.jpg',
      },
      completedContentOffset: {
        desktop: '-200px',
        mobile: '-150px',
      },
    },
  },
  i18nOverrides: {
    en: {
      cartWidget: {
        fixedFees: 'Ticket Fees',
        percentFees: 'Service Charge + Sales Tax',
      },
      reserveDateFirst: {
        selectDateLabel: 'Choose a Date',
      },
      selectAvailableSession: {
        title: 'Choose a time',
      },
      selectTickets: {
        title: 'Choose tickets',
      },
      applyPromoCodes: {
        applyAnotherPromoCodeLabel: 'Add another promo code',
        applyPromoCodeLabel: 'Add a promo code',
      },
    },
  },
}
